
import { MyAccountMenuActions } from "@dana/Store/Data/MyAccountMenu/Reducers/MyAccountMenuReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

interface MyaccountMenuToggleParameter {
    isOpen: boolean
}
type HandlerType = Handler<MyaccountMenuToggleParameter,
    DispatchProp<MyAccountMenuActions>
>;


export const MyaccountMenuToggloe: HandlerType = props => {
    props.dispatch({
        type: "MyAccountMenu/IsOpen",
        isOpen: props.parameter.isOpen,
    });

};


export const chain = [MyaccountMenuToggloe];

const toggleMyaccountMenu = createHandlerChainRunner(chain, "ToggleMyaccountMenu");
export default toggleMyaccountMenu;